import { useSelector } from 'react-redux';

import { generateKey, prettifyHour } from 'util';

export default function ProviderHours({ hours }) {
  const dowOptions = useSelector((state) => state.main.calendar.dayOfWeek);

  return (
    <div className="provider-hours flex-column">
      <div className="flex-row mb-12">
        <h4 className="day">Day</h4>
        <h4>Time</h4>
      </div>
      {dowOptions.map((el, i) => {
        const filteredData = hours.filter(
          (hour) => hour.dow.value === el.value
        );
        const hourBlock = filteredData[0];
        return (
          <div key={generateKey()} className="flex-row mb-12">
            <p className="day">{hourBlock ? hourBlock.dow.value : el.value}</p>
            <p className="hours">
              {hourBlock
                ? `${prettifyHour(hourBlock.time.start)} - ${prettifyHour(
                    hourBlock.time.end
                  )}`
                : 'Closed'}
            </p>
          </div>
        );
      })}
    </div>
  );
}
